
import { Outlet } from "react-router-dom";
import "./MainContent.css";
const MainContent = ( props ) => {


  return (
    <div className="landing-content">
      <Outlet />
    </div>
  );
};

export default MainContent;
